import React, { Component } from "react";
import { Empresa } from "smart-imob-types";
import EmpresaContext from "../../context";

class Mission extends Component {
  context!: Empresa;
  render() {
    let Spacer = <div style={{ height: 70 }} />;
    if (!this.context.info_gen) return Spacer;
    if (
      !this.context.info_gen.filo ||
      !this.context.info_gen.missao ||
      !this.context.info_gen.atendimento
    )
      return Spacer;
    return (
      <div className="mission-vission-area pd-top-80 pd-bottom-70">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="single-intro text-lg-left text-center">
                <div className="text">01</div>
                <div className="details">
                  <h4 className="title">
                    <a href="#">Nossa missão</a>
                  </h4>
                  <p>{this.context.info_gen.missao}</p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="single-intro text-lg-left text-center">
                <div className="text">02</div>
                <div className="details">
                  <h4 className="title">
                    <a href="#">Nossa visão</a>
                  </h4>
                  <p>{this.context.info_gen.atendimento}</p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="single-intro text-lg-left text-center">
                <div className="text">03</div>
                <div className="details">
                  <h4 className="title">
                    <a href="#">Nossos Valores</a>
                  </h4>
                  <p>{this.context.info_gen.filo}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Mission.contextType = EmpresaContext;
export default Mission;
